"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsDescriptionTextBox = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _underscore = require("underscore");
var _FormTextbox = require("../../FormTextbox");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SettingsDescriptionTextBox = exports.SettingsDescriptionTextBox = (0, _react.memo)(function (_ref) {
  var _ref$presenterDescrip = _ref.presenterDescription,
    _presenterDescription = _ref$presenterDescrip === void 0 ? '' : _ref$presenterDescrip,
    handlePresenterDescriptionChange = _ref.handlePresenterDescriptionChange,
    isDisabled = _ref.isDisabled;
  var _useState = (0, _react.useState)(_presenterDescription),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    presenterDescription = _useState2[0],
    setPresenterDescription = _useState2[1];
  var debouncedDescriptionChange = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function (value) {
      handlePresenterDescriptionChange(value);
    }, 300);
  }, [handlePresenterDescriptionChange]);
  var handleInputChange = function handleInputChange(value, setField) {
    var debounced = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    setField(value);
    if (debounced) {
      debouncedDescriptionChange(value);
    } else {
      handlePresenterDescriptionChange(value);
    }
  };
  var hasDescriptionExceededLimit = presenterDescription.trim().length > 80;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "title",
    id: "title",
    labelText: "Title",
    value: presenterDescription,
    onChange: function onChange(event) {
      return handleInputChange(event.target.value, setPresenterDescription);
    },
    onBlur: function onBlur(event) {
      return handleInputChange(event.target.value, setPresenterDescription, false);
    },
    disabled: isDisabled,
    hasError: hasDescriptionExceededLimit,
    errorMessage: hasDescriptionExceededLimit && "Title can't exceed 80 characters"
  }));
});